var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-item"},[(_vm.label != '')?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }